<template>
  <div class="flex h_100 home_container w_100 overHidden" :data-direction="getClass">
    <!-- <h1>{{$store.state.user.id}}</h1> -->
    <LeftBanner v-if="
      $store.state.user.id &&
      uiConfig.menuLocation !== 'bottom' &&
      uiConfig.menuLocation !== 'right' &&
      !shouldHideLeftBanner
    " />

    <div id="home_page" class="h_100 main-container relative" v-if="$store.state.user.id && loadingUser">
      <!-- 隐藏掉顶部条，改成水印方式 此处代码待删除-->
      <!-- <el-alert class="warning-tip" style="bottom: 0;" v-if="$store.state.usage == 2 || $store.state.usage == 3" :title="licenseTypeText" :closable="false" effect="dark" center type="error"></el-alert> -->

      <quick-b-i-panel-shell v-if="loadingUser" />

      <transition v-if="!isQuickBIPanelRoute" name="fade-transform" mode="out-in">
        <router-view></router-view>
      </transition>
      <!-- <socket v-if="$store.state.user.id" />  -->
      <water-mark dom-name="#home_page" :water-mask-text1="waterMaskText1" :water-mask-text2="waterMaskText2"
        v-if="shouldShowWaterMark" />
    </div>
    <LeftBanner v-if="
      $store.state.user.id &&
      (uiConfig.menuLocation == 'bottom' ||
        uiConfig.menuLocation == 'right')
    " />

    <el-dialog class="custom-dialog iframe-dialog" :visible.sync="iframeDialog" fullscreen destroy-on-close>
      <div slot="title" class="custom-dialog-title">
        <span class="circle_border el-icon-data-analysis"></span>{{ title }}
      </div>
      <div class="w_100" style="height: calc( 100vh - 64px );">
        <iframe class="w_100 h_100" style="border:none" :src="iframeUrl"></iframe>
      </div>
    </el-dialog>
    <!-- <messagePopup v-if="importMessage.length" :message-data="importMessage" /> -->
    <div v-if="isRobot && !shouldHideLeftBanner" class="robot-icon"
      :style="{ bottom: `${robotBottom}px`, right: `${robotRight}px` }" ref="robotIcon" @mousedown="startDrag"
      title="Open Beauty Buddy for AI Assistance">
      <el-image fit="contain" alt="小雅" src="static/elcLogo-bot.png" style="width:50px; height:50px;"></el-image>
    </div>

    <el-dialog :visible.sync="showRobotDialog" width="30%" height="calc(100vh - 100px)" custom-class="robot-dialog"
      :show-close="true" :close-on-click-modal="false">
      <iframe allow="clipboard-read; clipboard-write" v-if="robotUrl" :src="robotUrl" frameborder="0"
        style="width:100%; height:100%;"></iframe>
    </el-dialog>
  </div>
</template>

<script>
// import timeOut from "./timeOut"
import LeftBanner from "../../components/leftBanner";
import QuickBIPanelShell from "./QuickBIPanelShell.vue";
import { isQuickBIPanelRoute } from "@/utils/quickBIPanelCache";
import { uuid } from "../../utils/util.js";
// import messagePopup from "@/views/login/messagePopup";
import socket from "./socket";
import WaterMark from "./waterMark";
import { baseIp } from "@/config/env";
import { GetServerDateTime } from "@/api/config";

export default {
  components: { LeftBanner, QuickBIPanelShell, socket, WaterMark },
  data() {
    return {
      uuid: uuid(),
      onlineUserTimer: null, //在线用户的定时器
      iframeDialog: false,
      title: "",
      iframeUrl: "",
      robotObj: null,
      loadingUser: false,
      importMessage: [],
      showWaterMark: false,
      waterMaskText1: "", //水印文字1
      waterMaskText2: "", //水印文字2
      showRobotDialog: false,
      robotUrl: '',
      robotBottom: 80,
      robotRight: 80,
      dragging: false,
      offsetX: 0,
      offsetY: 0,
      dragWidth: 0,
      dragHeight: 0,
      startX: 0,
      startY: 0,
    };
  },
  computed: {
    // 是否新页签打开报表
    isNewWindowsOpen() {
      return this.$route.name === 'reportView' &&
        this.$route.query.open == 2 || this.$route.query.open == 3;
    },
    socketType() {
      return this.$store.state.socketType;
    },
    uiConfig() {
      return this.$store.state.uiConfig;
    },
    getClass() {
      const { uiConfig } = this.$store.state;
      return uiConfig.menuLocation || "";
    },
    // 判断是否应该LeftBanner
    shouldHideLeftBanner() {
      console.log(this.$route.name)
      console.log(this.$route.query.open)
      return this.$route.name === 'reportView' &&
        (this.$route.query.open == 2 || this.$route.query.open == 3);
    },
    isRobot() {
      return this.$store.state.isRobot;
    },
    user() {
      return this.$store.state.user;
    },
    // 根据路由名称判断是否显示水印
    isQuickBIPanelRoute() {
      return isQuickBIPanelRoute(this.$route);
    },
    shouldShowWaterMark() {
      console.log('路由名称:', this.$route.name)
      console.log('路由路径:', this.$route.path)
      console.log('showWaterMark:', this.showWaterMark)
      
      // 如果基础水印开关关闭，不显示
      if (!this.showWaterMark) {
        return false;
      }
      
      // 当路由名称是 reportList 时不显示水印
      if (this.$route.name === 'reportList') {
        return false;
      }
      
      // 当路由路径完全匹配 /about/task/dataManagement 时不显示水印（填报列表页）
      if (this.$route.path === '/about/task/dataManagement') {
        return false;
      }
      
      // 其他情况显示水印（包括 /about/task/dataManagement/37 这样的具体填报项）
      return true;
    },
  },
  watch: {
    socketType(va) {
      if (va == 2) {
        const _this = this;

        _this.$store.commit("clearToken");
        _this.$store.commit("setSocketType", null);
        _this
          .$confirm(
            _this.$translate("forceToLogOffAndRelogin"),
            _this.$translate("tips"),
            {
              confirmButtonText: _this.$translate("sure"),
              showCancelButton: false,
              closeOnClickModal: false,
              closeOnPressEscape: false,
              showClose: false,
              type: "warning",
            }
          )
          .then(() => {
            _this.$store.commit("logout");
          });
      }
    },
  },
  mounted() {
    //新窗口打开报表，不检查license
    if (!this.isNewWindowsOpen) {
      this.checkLicense();

    }
    this.init();
    // this.openImportNotice();
  },
  destroyed() {
    clearInterval(this.checkTokenTimer);
  },
  methods: {
    init() {
      //先checkToken一次，避免刷新多次造成checkToken时间过长
      this.$store.dispatch("setTimeCheckToken");

      clearInterval(this.checkTokenTimer);
      /**
       * 开启checkToken定时器
       */
      this.checkTokenTimer = setInterval(() => {
        this.$store.dispatch("setTimeCheckToken");
      }, 10 * 60000);

      /**
       * 获取当前用户的基础信息
       */
      if (this.$store.state.user.id) {
        this.loadingUser = true;
        this.loadUserAfterFn();
      } else {
        this.$store.dispatch("getCurrentUser").then(() => {
          this.loadingUser = true;
          this.loadUserAfterFn();
        });
      }

      this.$store.dispatch("getChangeConfig").then(() => {
        this.setWaterMarkFromConfig();
      });

      // this.openOnlineUserTimer();
    },
    loadUserAfterFn() {
      this.$store.dispatch("getChangeConfig");
    },
    // 从store中获取配置数据并设置水印
    setWaterMarkFromConfig() {
      const waterMaskConfig = this.$store.state.waterMaskText;
      console.log('开始设置水印内容', waterMaskConfig)
      //console.log('路由名称:', this.$route.name)

      if (waterMaskConfig.Enable) {

        let waterMaskText = this.$store.state.waterMaskText.Title;
        //TITLE 替换{{date}}
        if (waterMaskText && waterMaskText.includes('{{date}}')) {
          GetServerDateTime().then(res => {

            if (res && res.data) {
              console.log('res.data', res.data)
              // 只保留日期部分，去掉时间部分
              const dateOnly = res.data.split(' ')[0];
              waterMaskText = waterMaskText.replace('{{date}}', dateOnly);
              console.log('waterMaskTextAfter', waterMaskText)
              this.waterMaskText1 = waterMaskText
              this.waterMaskText2 = this.$store.state.waterMaskText.UseUserName
                ? this.$store.state.user.fullName : "";
              this.showWaterMark = true;

            }
          })
        } else {
          this.waterMaskText1 = this.$store.state.waterMaskText.Title;
          this.waterMaskText2 = this.$store.state.waterMaskText.UseUserName
            ? this.$store.state.user.fullName : "";
          this.showWaterMark = true;
        }

      }
    },
    checkLicense() {
      this.$api.License.CheckLicenseState().then((res) => {
        if (res) {
          if (res.isSuccess) {
            this.$store.commit("setLicenseStatus", false);
            /* const { usage } = res.data;
            if (usage && (usage == 2 || usage == 3)) {
            //系统的授权状态 1.正式使用 2.客户试用。 3.内部测试 
              const text =
                usage == 2
                  ? this.$translate("customerAuthorization")
                  : this.$translate("testAuthorization");
              this.waterMaskText = text;
              this.showWaterMark = true;
            } */
          } else {
            this.$store.commit("setLicenseStatus", true);
            this.$router.push({ name: "CheckLicense" });
          }
        }
      });
    },
    // openImportNotice() {
    //   if (localStorage["_EBINOTIPSMESSAGE"]) return;
    //   this.$api.Announcement.GetAnnouncementPopup().then((res) => {
    //     if (res && res.isSuccess) {
    //       this.importMessage = res.data || [];
    //     }
    //   });
    // },
    openRobot() {
      console.log(this.user)
      this.$api.AI.GenerateUrl(this.user.id).then(res => {
        if (res.isSuccess) {
          this.robotUrl = res.data;
          this.showRobotDialog = true;
        }
      }).catch(error => {
        this.$message.error('API call failed: ' + error.message);
      });
    },
    startDrag(e) {
      e.preventDefault();
      const rect = this.$refs.robotIcon.getBoundingClientRect();
      this.offsetX = e.clientX - rect.left;
      this.offsetY = e.clientY - rect.top;
      this.dragWidth = rect.width;
      this.dragHeight = rect.height;
      this.startX = e.clientX;
      this.startY = e.clientY;
      this.dragging = true;
      document.addEventListener('mousemove', this.doDrag);
      document.addEventListener('mouseup', this.stopDrag);
    },
    doDrag(e) {
      if (!this.dragging) return;
      const newLeft = e.clientX - this.offsetX;
      const newTop = e.clientY - this.offsetY;
      let newRight = window.innerWidth - newLeft - this.dragWidth;
      let newBottom = window.innerHeight - newTop - this.dragHeight;
      this.robotRight = Math.max(0, newRight);
      this.robotBottom = Math.max(0, newBottom);
    },
    stopDrag(e) {
      this.dragging = false;
      document.removeEventListener('mousemove', this.doDrag);
      document.removeEventListener('mouseup', this.stopDrag);
      const dx = Math.abs(e.clientX - this.startX);
      const dy = Math.abs(e.clientY - this.startY);
      if (dx <= 3 && dy <= 3) {
        this.openRobot();
      }
    },
  },
};
</script>

<style lang="scss">
.robot-icon {
  position: fixed;
  z-index: 1000;
  cursor: move;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
  border-radius: 50%;

  &:hover {
    cursor: pointer;
  }
}

.robot-dialog {
  position: fixed !important;
  top: 10px !important;
  bottom: 40px !important; // increased to move up
  left: auto !important;
  right: 80px !important; // increased to move left
  margin: 0 !important;
}

.robot-dialog .el-dialog__body {
  height: 100%;
  padding: 0;
}

.robot-dialog .el-dialog__headerbtn {
  top: 10px;
}
</style>
